import firebase from "@/firebase";
import { FS_COLLECTIONS } from "@/firebase";
//const storage = firebase.storage().ref();
const db = firebase.firestore();

const store = {
  state: {
    indice_productos_lista: {},
    productosPorCategoria: [],
    productosPorSubcategoria: [],
    productosPorLinea: [],
    productosPorPrincipales: [],
    productosPorPrincipalesGeneral: [],
    catalogo_productos: {},
    productoSelect: {},
    productosSucursal: {},
    productosLista: {}
  },
  getters: {
    /*dataProductos: state => {
        return state.dataProductos;
      },*/
    catalogoProductos: state => {
      return state.catalogoProductos;
    },
    productosPorCategoria: state => {
      return state.productosPorCategoria;
    },
    productosPorSubcategoria: state => {
      return state.productosPorSubcategoria;
    },
    productosPorLinea: state => {
      return state.productosPorLinea;
    },
    productosPorPrincipales: state => {
      return state.productosPorPrincipales;
    },
    productosPorPrincipalesGeneral: state => {
      return state.productosPorPrincipalesGeneral;
    },
    productoSeleccionado: state => {
      return state.productoSelect;
    },
    indiceProductosLista: state => {
      return state.indice_productos_lista;
    },
    dataProductosSucursal: state => {
      return state.productosSucursal;
    },
    productosLista: state => {
      return state.productosLista;
    }
  },
  mutations: {
    /*ASIGNA_PRODUCTOS(state, data){
        state.dataProductos = data;
      },*/
    ASIGNA_PRODUCTOS_LISTA(state, data) {
      state.productosLista = data;
    },
    ASIGNA_CATALOGO_PRODUCTOS(state, data) {
      state.catalogoProductos = data;
    },
    ASIGNA_PRODUCTOS_POR_CATEGORIA(state, data) {
      state.productosPorCategoria = data;
    },
    ASIGNA_PRODUCTOS_POR_SUBCATEGORIA(state, data) {
      state.productosPorSubcategoria = data;
    },
    ASIGNA_PRODUCTOS_POR_LINEA(state, data) {
      state.productosPorLinea = data;
    },
    ASIGNA_PRODUCTOS_POR_PRINCIPALES(state, data) {
      state.productosPorPrincipales = data;
    },
    ASIGNA_PRODUCTOS_POR_PRINCIPALES_GENERAL(state, data) {
      state.productosPorPrincipalesGeneral = data;
    },
    ASIGNA_PRODUCTO_SELECCIONADO(state, data) {
      state.productoSelect = data;
    },
    ASIGNA_INDICE_PRODUCTOS_LISTA(state, data) {
      state.indice_productos_lista = data;
    },
    ASIGNA_PRODUCTOS_SUCURSAL(state, data) {
      state.productosSucursal = data;
    }
  },
  actions: {
    restablecerValoresProductos({ commit }) {
      commit("ASIGNA_PRODUCTO_SELECCIONADO", {});
      commit("ASIGNA_CATALOGO_PRODUCTOS", {});
      commit("ASIGNA_PRODUCTOS_POR_CATEGORIA", []);
      commit("ASIGNA_PRODUCTOS_POR_SUBCATEGORIA", []);
      commit("ASIGNA_PRODUCTOS_POR_LINEA", []);
      commit("ASIGNA_PRODUCTOS_POR_PRINCIPALES", []);
    },

    async cargarNombresRutaProducto({ getters }, productoData) {
      const id_franquicia = getters.usuario.id_franquicia
      const categoriasRef = db.collection("Franquicias").doc(id_franquicia)
        .collection("Catalogos").doc("ProductosV2").collection('Categorias');

      const categoriaRef = categoriasRef.doc(productoData.id_nivel1);
      const subCategoriaRef = categoriaRef.collection('Subcategorias').doc(productoData.id_nivel2);
      const lineaRef = subCategoriaRef.collection('Lineas').doc(productoData.id_nivel3);

      try {
        const [docCategoria, docSubCategoria, docLinea] = await Promise.all([
          categoriaRef.get(),
          subCategoriaRef.get(),
          lineaRef.get()
        ]);
        return {
          categoria: docCategoria.data().name,
          subcategoria: docSubCategoria.data().name,
          linea: docLinea.data().name
        };
      } catch (error) {
        console.error("Error cargando nombres de ruta:", error);
        throw error; // Propaga el error para que pueda ser manejado en otro lugar si es necesario
      }
    },

    cargaProductoSeleccionado({ commit, getters }, idProducto) {
      console.log("Store producto carga: " + idProducto);
      return new Promise((resolve, reject) => {
        let docPath = db
          .collection("Franquicias")
          .doc(getters.franquicia.id)
          .collection("Productos")
          .doc(idProducto);
        docPath.get().then(doc => {
          console.log(doc.data());
          commit("ASIGNA_PRODUCTO_SELECCIONADO", doc.data());
          resolve(doc.data());
        });
      });
    },
    cargaProductosLista({ getters, commit }) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES)
          .doc("ProductosLista")
          .onSnapshot(querySnapshot => {
            commit("ASIGNA_PRODUCTOS_LISTA", querySnapshot.data());
            resolve();
          });
      });
    },
    cargaProductosListaV2({ getters, commit }) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES)
          .doc("CatalogosV2")
          .collection("ProductosListaV2")
          .onSnapshot(snapshot => {
            const listaFull = {};
            snapshot.forEach(e => {
              const productos = e.data() || {};
              for (const i in productos) {
                listaFull[i] = {
                  ...productos[i],
                  id: i
                };
              }
            });
            console.log(
              "🚀 ~ file: productos.js:144 ~ returnnewPromise ~ listaFull:",
              listaFull
            );
            commit("ASIGNA_PRODUCTOS_LISTA", listaFull);
            resolve(listaFull);
          });
      });
    },

    migrarProductosV1AV2({ getters, commit }) {
      const batchSize = 100; // Número de objetos por lote
      return new Promise(async (resolve, reject) => {
        try {
          // Obtiene una referencia al documento actual
          const docRef = db
            .collection("Sucursales")
            .doc("R9ilNpBz77lK0dmknZsC")
            .collection("Indices");
          const docSnapshot = await docRef.doc("Productos").get();

          if (docSnapshot.exists) {
            const data = docSnapshot.data();
            const productosIds = Object.keys(data);
            const totalProductos = productosIds.length;

            for (let i = 0; i < totalProductos; i += batchSize) {
              // Divide los productos en lotes de tamaño batchSize
              const batchProductos = productosIds.slice(i, i + batchSize);

              // Crea un nuevo documento para cada lote
              //Sucursales/g49LKDO9aoPTCle2FSnr/Indices/CatalogosV2/ProductosV2/Productos_3
              const nuevoDocRef = docRef
                .doc("CatalogosV2")
                .collection("ProductosV2")
                .doc(`Productos_${i / batchSize}`);

              // Obtiene los datos del lote actual
              const batchData = {};
              batchProductos.forEach(id => {
                batchData[id] = data[id];
              });
              console.log("Migración numero:" + i);

              // Sube los datos al nuevo documento
              await nuevoDocRef.set(batchData);
            }

            console.log("Migración completada.");
            resolve("Migración completada.");
          } else {
            console.log("El documento no existe.");
            resolve("El documento no existe.");
          }
        } catch (error) {
          console.error("Error al migrar los datos:", error);
          reject(error);
        }
      });
    },
    migrarProductosFranquiciaV1AV2({ getters, commit }) {
      const batchSize = 100; // Número de objetos por lote
      return new Promise(async (resolve, reject) => {
        try {
          // Obtiene una referencia al documento actual
          const docRef = db
            .collection("Franquicias")
            .doc("BvMprX2oCD7SnWGJHOd9")
            .collection("Indices");
          const docSnapshot = await docRef.doc("ProductosLista").get();

          if (docSnapshot.exists) {
            const data = docSnapshot.data();
            const productosIds = Object.keys(data);
            const totalProductos = productosIds.length;

            for (let i = 0; i < totalProductos; i += batchSize) {
              // Divide los productos en lotes de tamaño batchSize
              const batchProductos = productosIds.slice(i, i + batchSize);

              // Crea un nuevo documento para cada lote
              //Franquicias/NgSwQwNgH2L92XtH5cy1/Indices/CatalogosV2/ProductosListaV2/Productos_3
              const nuevoDocRef = docRef
                .doc("CatalogosV2")
                .collection("ProductosListaV2")
                .doc(`Productos_${i / batchSize}`);

              // Obtiene los datos del lote actual
              const batchData = {};
              batchProductos.forEach(id => {
                batchData[id] = data[id];
              });
              console.log("Migración numero:" + i);

              // Sube los datos al nuevo documento
              await nuevoDocRef.set(batchData);
            }

            console.log("Migración completada.");
            resolve("Migración completada.");
          } else {
            console.log("El documento no existe.");
            resolve("El documento no existe.");
          }
        } catch (error) {
          console.error("Error al migrar los datos:", error);
          reject(error);
        }
      });
    },
    actualizaProductoSeleccionado({ getters }, data) {
      console.log(data);
      db.collection("Franquicias")
        .doc(getters.franquicia.id)
        .collection("Productos")
        .doc(data[1])
        .set(data[0]);
      db.collection("Franquicias")
        .doc(getters.franquicia.id)
        .collection("Catalogos")
        .doc("Productos")
        .set(data[2]);
      //console.log(data[0].nombre);
    },
    cargaProductos({ getters, commit }) {
      return new Promise((resolve, reject) => {
        db.collection("Franquicias")
          .doc(getters.franquicia.id)
          .collection("Catalogos")
          .doc("Productos")
          .get()
          .then(querySnapshot => {
            //commit('ASIGNA_SERVICIOS',querySnapshot.data());
            commit("ASIGNA_CATALOGO_PRODUCTOS", querySnapshot.data());
            let productos_categoria = [];
            let productos_subcategoria = [];
            let productos_linea = [];
            let productos_principales = [];
            let productos_principales_general = [];
            for (var i in querySnapshot.data().children) {
              if (!querySnapshot.data().children[i].delete) {
                let categoria = querySnapshot.data().children[i];
                for (var j in categoria.children) {
                  if (Object.keys(categoria.children[j]).length > 0) {
                    if (!categoria.children[j].delete) {
                      let subcategoria = categoria.children[j];
                      for (var k in subcategoria.children) {
                        if (Object.keys(subcategoria.children[k]).length > 0) {
                          if (!subcategoria.children[k].delete) {
                            let linea = subcategoria.children[k];
                            for (var l in linea.children) {
                              if (Object.keys(linea.children[l]).length > 0) {
                                //productos_principales_general.push(linea.children[l])
                                if (!linea.children[l].delete) {
                                  var principal = linea.children[l];
                                  productos_principales.push(principal);
                                }
                              }
                            }
                            delete linea.children;
                            productos_linea.push(linea);
                            //servicios_principales.push(servicio_normal);
                          }
                        }
                      }
                      //Añadir subcategoria a array de subcategorias del servicio
                      delete subcategoria.children;
                      productos_subcategoria.push(subcategoria);
                    }
                  }
                }
                //Añadir categorias a array de categorias del servicio
                delete categoria.children;
                productos_categoria.push(categoria);
              }
            }
            commit("ASIGNA_PRODUCTOS_POR_CATEGORIA", productos_categoria);
            commit("ASIGNA_PRODUCTOS_POR_SUBCATEGORIA", productos_subcategoria);
            commit("ASIGNA_PRODUCTOS_POR_LINEA", productos_linea);
            commit("ASIGNA_PRODUCTOS_POR_PRINCIPALES", productos_principales);
            //commit('ASIGNA_PRODUCTOS_POR_PRINCIPALES_GENERAL',productos_principales_general)
            //commit('ASIGNA_SERVICIOS_POR_SUBCATEGORIA',servicios_subcategoria)
            //commit('ASIGNA_SERVICIOS_POR_PRINCIPALES',servicios_principales)
            //console.log("PRODUCTOS CON CATEGORIA ENCONTRADOS")
            //console.log(productos_categoria)
            //console.log("Subcategorias de los productos encontrados")
            //console.log(productos_subcategoria)
            //console.log("Productos con linea encontrados")
            //console.log(productos_linea)
            //console.log("Productos principales")
            //console.log(productos_principales)
            resolve(querySnapshot.data());
          });
      });
    },
    cargaProductosParaActualizacion({ getters, commit }) {
      return new Promise((resolve, reject) => {
        db.collection("Franquicias")
          .doc(getters.franquicia.id)
          .collection("Catalogos")
          .doc("Productos")
          .get()
          .then(querySnapshot => {
            let productos_principales_general = [];
            for (var i in querySnapshot.data().children) {
              let categoria = querySnapshot.data().children[i];
              for (var j in categoria.children) {
                if (Object.keys(categoria.children[j]).length > 0) {
                  let subcategoria = categoria.children[j];
                  for (var k in subcategoria.children) {
                    if (Object.keys(subcategoria.children[k]).length > 0) {
                      let linea = subcategoria.children[k];
                      for (var l in linea.children) {
                        if (Object.keys(linea.children[l]).length > 0) {
                          productos_principales_general.push(linea.children[l]);
                        }
                      }
                    }
                  }
                }
              }
            }
            commit(
              "ASIGNA_PRODUCTOS_POR_PRINCIPALES_GENERAL",
              productos_principales_general
            );
            resolve(productos_principales_general);
          });
      });
    },
    /*cargaProductos({commit}){
      db.collection("Franquicias").doc("WBYam9VrXE2kNtlb6J5S")
      .collection("Indices").doc("Productos").get().then((querySnapshot) => {
        commit('ASIGNA_PRODUCTOS',querySnapshot.data());
      });
    },*/
    cargaProductosSucursal({ commit }, idSucursal) {
      db.collection("Sucursales")
        .doc(idSucursal)
        .collection("Indices")
        .doc("Productos")
        .onSnapshot(querySnapshot => {
          let productos =
            querySnapshot.data() !== undefined ? querySnapshot.data() : {};
          commit("ASIGNA_PRODUCTOS_SUCURSAL", productos);
        });
    },
    cargaProductosSucursalV2({ commit }, idSucursal) {
      // Cambia get() a onSnapshot()
      db.collection("Sucursales")
        .doc(idSucursal)
        .collection("Indices")
        .doc("CatalogosV2")
        .collection("ProductosV2")
        .onSnapshot(snapshot => {
          const listaFull = {};
          snapshot.forEach(e => {
            const productos = e.data() || {};
            for (const i in productos) {
              listaFull[i] = {
                ...productos[i],
                id: i
              };
            }
          });
          commit("ASIGNA_PRODUCTOS_SUCURSAL", listaFull);
        });
    },
    cargaListaProductos({ getters, commit }) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES)
          .doc("ProductosLista")
          .onSnapshot(querySnapshot => {
            let listaProductos =
              querySnapshot.data() !== undefined ? querySnapshot.data() : {};
            commit("ASIGNA_INDICE_PRODUCTOS_LISTA", listaProductos);
            resolve(listaProductos);
          });
      });
    },
    inhabilitarProducto({ getters }, idProducto) {
      var obj = { estatus: { activo: "baja" } };
      return db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection("Productos")
        .doc(idProducto)
        .set(obj, { merge: true });
    },
    actualizarProductosV1({ getters, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch("cargaProductosParaActualizacion")
          .then(() => {
            dispatch("cargaListaProductos")
              .then(() => {
                console.log(
                  "Actualizar productos carga productos",
                  getters.productosPorPrincipalesGeneral
                );
                //Creamos las transacciones para actualizar los datos
                var batch = db.batch();
                let productos = getters.productosPorPrincipalesGeneral;
                let productos_lista = getters.indiceProductosLista;
                console.log(
                  "Actualizar productos carga lista",
                  productos_lista
                );
                //Recorremos la lista de productos a nivel franquicia
                /*for(var i in productos_lista){
              for(var j in productos){
                if(i==productos[j].id){
                  if(productos[j].delete){
                    necesita_actualizar = true;
                  }
                }
              }
            }*/
                for (var i in productos_lista) {
                  let p_temp = null;
                  let encontrado = false;
                  for (var j in productos) {
                    if (productos[j].id == i) {
                      p_temp = productos[j];
                      encontrado = true;
                    }
                  }
                  if (p_temp !== null) {
                    console.log("Producto encontrado", p_temp);
                    if (p_temp.delete) {
                      let ref = db
                        .collection(FS_COLLECTIONS.FRANQUICIAS)
                        .doc(getters.franquicia.id)
                        .collection(FS_COLLECTIONS.PRODUCTOS)
                        .doc(p_temp.id);
                      batch.set(
                        ref,
                        { estatus: { activo: "baja" } },
                        { merge: true }
                      );
                    } else {
                      let ref = db
                        .collection(FS_COLLECTIONS.FRANQUICIAS)
                        .doc(getters.franquicia.id)
                        .collection(FS_COLLECTIONS.PRODUCTOS)
                        .doc(p_temp.id);
                      batch.set(
                        ref,
                        { estatus: { activo: "activo" } },
                        { merge: true }
                      );
                    }
                  } else {
                    console.log("Producto no se encontro", productos_lista[i]);
                    let ref = db
                      .collection(FS_COLLECTIONS.FRANQUICIAS)
                      .doc(getters.franquicia.id)
                      .collection(FS_COLLECTIONS.PRODUCTOS)
                      .doc(i);
                    batch.set(
                      ref,
                      { estatus: { activo: "baja" } },
                      { merge: true }
                    );
                  }
                  //console.log("Encontrado " + i + " " + encontrado)
                  //console.log("Temp encontrato producto", p_temp)
                }
                //Cuando todas las transacciones estan listas se ejecuta esta linea
                batch
                  .commit()
                  .then(() => {
                    console.log("STORE TERMINA EJECUCION PRODUCTOS");
                    resolve(true);
                    //Actualizamos rama de productos a version 1.0
                    db.collection(FS_COLLECTIONS.FRANQUICIAS)
                      .doc(getters.franquicia.id)
                      .collection(FS_COLLECTIONS.CATALOGOS)
                      .doc(FS_COLLECTIONS.PRODUCTOS)
                      .set({ version: "1.0" }, { merge: true })
                      .then(() => {
                        resolve(true);
                      })
                      .catch(error => {
                        reject(error);
                      });
                  })
                  .catch(error => {
                    reject(error);
                  });
              })
              .catch(error => {
                reject(error);
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // -..--.-.-.-.-.+.+.++.+.+.+.++.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.+.
    migrarProductos({ }) { }
  }
};
export default store;



// WEBPACK FOOTER //
// ./src/store/productos/productos.js